export const COUNTDOWN_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "icon",
      },
      {
        value: "text",
      },
      {
        value: "label",
      },
    ],
    title: "Get ready for launch day!",
    text: "Mark your calendars and make sure to be there, you don’t want to miss this edition.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "custom-color",
    borderRadius: 8,
    colorFields: {
      Timer: { light: "#00C54B", dark: "#00C54B" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "text",
      },
      {
        value: "label",
      },
      {
        value: "arrow",
      },
    ],
    title: "SS24 Launch",
    text: "Mark your calendars and make sure to be there, you don’t want to miss this edition.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "small-countdown",
    borderRadius: 13,
    colorFields: {
      Timer: { light: "#003BFF", dark: "#003BFF" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "text",
      },
      {
        value: "label",
      },
      {
        value: "arrow",
      },
    ],
    title: "Launch of our new website",
    text: "Launch of our new website with a fresh design, improved navigation, and a better experience for our users.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "background",
    borderRadius: 13,
    colorFields: {
      Timer: { light: "#003BFF", dark: "#003BFF" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
    image: {
      source: "unsplash",
      link: "https://images.unsplash.com/photo-1706804285677-4eb783c82642?q=80&w=600&h=800",
      id: "OHqbSPQC1qs",
    },
  },
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "icon",
      },
      {
        value: "text",
      },
      {
        value: "label",
      },
    ],
    title: "Get ready for launch day!",
    text: "Mark your calendars and make sure to be there, you don’t want to miss this edition.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "fixed-color",
    borderRadius: 8,
    colorFields: {
      Timer: { light: "#000000", dark: "#000000" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
];

export const OVERVIEW_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "icon",
      },
    ],
    title: "Get ready for launch day!",
    text: "Mark your calendars and make sure to be there, you don’t want to miss this edition.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "custom-color",
    borderRadius: 8,
    colorFields: {
      Timer: { light: "#00C54B", dark: "#00C54B" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "text",
      },
      {
        value: "label",
      },
      {
        value: "arrow",
      },
    ],
    title: "SS24 Launch",
    text: "Mark your calendars and make sure to be there.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "small-countdown",
    borderRadius: 13,
    colorFields: {
      Timer: { light: "#003BFF", dark: "#003BFF" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
  {
    id: crypto.randomUUID(),
    alignment: "center",
    timerLayout: [
      {
        value: "icon",
      },
      {
        value: "text",
      },
      {
        value: "label",
      },
    ],
    title: "Get ready for launch day!",
    text: "Mark your calendars and make sure to be there, you don’t want to miss this edition.",
    time: new Date(new Date().setDate(30)).toISOString(),
    format: "24",
    timerType: "fixed-color",
    borderRadius: 8,
    colorFields: {
      Timer: { light: "#000000", dark: "#000000" }, // used to support old color design
    },
    // new settings
    colorMute: false,
    linkText: "Read more",
    url: {},
    newTab: true,
    icon: {
      id: "man-lifting-weights",
      name: "Man Lifting Weights",
      short_names: ["man-lifting-weights"],
      colons: ":man-lifting-weights:",
      emoticons: [],
      unified: "1f3cb-fe0f-200d-2642-fe0f",
      skin: 1,
      native: "🏋️‍♂️",
    },
  },
];

export const getCountdownTemplates = ({
  cornerRadius,
  selectedColors,
  isInOverview = false,
}) => {
  return (isInOverview ? OVERVIEW_TEMPLATES : COUNTDOWN_TEMPLATES).map(
    (template) => ({
      ...template,
      borderRadius: cornerRadius || 13,
      colorFields: {
        Timer: {
          light: selectedColors?.accent?.light || "#003BFF",
          dark: selectedColors?.accent?.dark || "#003BFF",
        },
      },
    })
  );
};
